import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Grid, Input, Tab, Dimmer, Loader} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {TOYOTA_RUC} from '../../../common/constants/dealer';
import {Actions} from '../../../common/actions';
import Summary from './summary';
import PartsDetail from './detail';

const today = moment();
const PANES_INDICES = {
  'PARTS_TO_ORDER': 0,
  'PARTS_ORDERED': 1,
};
const panes = [
  {'menuItem': 'Accesorios por pedir'},
  {'menuItem': 'Accesorios pedidos'},
];

class SetOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
    };
    this.onAskForClick = this.onAskForClick.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.changeTabIndex = this.changeTabIndex.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.SetsOrders, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.onSearchClick();
  }

  onSearchClick() {
    const {startDateFilter, endDateFilter, activeTabIndex} = this.state;
    const orderWasPlaced = (activeTabIndex === 0 ? 'NO' : 'SI');
    this.props.fetchSummarySetsOrders(startDateFilter, endDateFilter, orderWasPlaced);
  }

  onCancelClick() {
    this.setState({
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
    }, () => {
      this.onSearchClick();
    });
  }

  onAskForClick() {
    const {chassisList} = this.props;
    const {startDateFilter, endDateFilter} = this.state;
    const data = {
      'agency': '02',
      'dealer': TOYOTA_RUC,
      'chassis': chassisList,
      'orders': this.getPartsList(),
    };
    this.props.requestOrderToCpd(data, startDateFilter, endDateFilter, true, null);
  }

  getPartsList() {
    const {partsList} = this.props;
    const orders = [];

    partsList.forEach((item) => {
      orders.push({'partCode': item.partCode, 'partQuantity': item.totalQuantity,
        'partName': item.partName});
    });
    return orders;
  }

  updateSearchFilters(value, filterName) {
    const newState = {};
    newState[filterName] = value;
    this.setState(newState);
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted === startDateFilter) {
      return;
    }
    this.updateSearchFilters(dateFormatted, 'startDateFilter');
    if (!endDateFilter || (endDateFilter && moment(date) > moment(endDateFilter))) {
      this.updateSearchFilters(dateFormatted, 'endDateFilter');
    }
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted === this.state.endDateFilter) {
      return;
    }
    this.updateSearchFilters(dateFormatted, 'endDateFilter');
  }

  changeTabIndex(event, data) {
    const {loading, saving} = this.props;
    if (loading || saving) {
      return;
    }

    this.setState({
      'activeTabIndex': data.activeIndex,
    }, () => this.onSearchClick());
  }

  renderAskButton() {
    const {loading, saving, partsList} = this.props;
    const {activeTabIndex} = this.state;
    if (activeTabIndex === PANES_INDICES.PARTS_ORDERED) {
      return null;
    }
    return (
      <Button
        primary
        type='submit'
        className='toyota-primary'
        disabled={loading || saving || !partsList.length}
        onClick={this.onAskForClick}
      >
        Pedir
      </Button>
    );
  }

  renderFiltersSection() {
    const {startDateFilter, endDateFilter} = this.state;
    const {loading, saving} = this.props;

    return (
      <div className='filters-section'>
        <Grid textAlign='left'>
          <Grid.Row>
            <Grid.Column width={2}>
              <h4>Fecha Inicio</h4>
            </Grid.Column>
            <Grid.Column width={2}>
              <DatePicker
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={
                  startDateFilter ?
                    moment(startDateFilter, noTimeZoneShortISODate).toDate() :
                    null
                }
                onChange={this.changeStartDate}
                disabled={loading || saving}
                locale='es'
                placeholderText='Fecha Inicio'
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <h4>Fecha Fin</h4>
            </Grid.Column>
            <Grid.Column width={2}>
              <DatePicker
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                selected={
                  endDateFilter ?
                    moment(endDateFilter, noTimeZoneShortISODate).toDate() :
                    null
                }
                onChange={this.changeEndDate}
                disabled={!startDateFilter || loading || saving}
                minDate={moment(startDateFilter).toDate()}
                placeholderText='Fecha Fin'
                locale='es'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  renderPanesContent() {
    const {activeTabIndex} = this.state;
    
    switch (activeTabIndex) {
      default:
      case PANES_INDICES.PARTS_TO_ORDER:
        return (
          <div>
            {this.renderLoader()}
            <PartsDetail activeTabIndex={activeTabIndex} />
            <Summary />
          </div>
        );
      case PANES_INDICES.PARTS_ORDERED:
        return (
          <div>
            <PartsDetail activeTabIndex={activeTabIndex} />
            <Summary />
          </div>
        );
    }
  }

  renderLoader() {
    const {saving} = this.props;
    if (!saving) {
      return null;
    }

    return (
      <Dimmer active inverted>
        <Loader inverted content='Procesando' />
      </Dimmer>
    );
  }

  render() {
    const {activeTabIndex} = this.state;
    const {loading, saving} = this.props;

    return (
      <div className='set-orders'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Pedidos de Combos</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={loading || saving}
                  onClick={this.onCancelClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={loading || saving}
                  onClick={this.onSearchClick}
                >
                  Buscar
                </Button>
                {this.renderAskButton()}
              </div>
            </div>

            {this.renderFiltersSection()}
          </div>

          <Tab
            menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
            panes={panes}
            activeIndex={activeTabIndex}
            onTabChange={this.changeTabIndex}
          />
        </Card>
        {this.renderPanesContent()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.setsOrders.loading,
    'saving': state.setsOrders.saving,
    'chassisList': state.setsOrders.chassisList,
    'partsList': state.setsOrders.partsList,
    'permissions': state.session.permissions,
  };
};

const {
  fetchSummarySetsOrders,
  requestOrderToCpd,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchSummarySetsOrders,
  requestOrderToCpd,
  navigateTo,
})(SetOrders);
